import React from 'react';
import PropTypes from 'prop-types';
import {CheckboxRadioContextProvider} from './CheckboxRadioContext';

const CheckboxRadioGroup = props => {
  const {Component = 'div', name, value, onChange, children, type, ...rest} = props;

  return (
    <Component {...rest}>
      <fieldset>
        <CheckboxRadioContextProvider
          value={{
            checkedValues: value,
            inputType: type,
            onChange,
            name,
          }}
        >
          {children}
        </CheckboxRadioContextProvider>
      </fieldset>
    </Component>
  );
};

CheckboxRadioGroup.propTypes = {
  Component: PropTypes.elementType,
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
};

export default CheckboxRadioGroup;
